import React, { useState } from 'react';
import { SearchRewardCategory } from './searchRewardCategory';

import './rewardAdmin.scss'
import { Link } from 'react-router-dom';
import {Col, Row} from "reactstrap";
import {FaPlus} from "react-icons/fa";
export function AdminRewardCategory() {
    const [refresh, setRefresh] = useState(0);

    return (
        <>
            <div className="admin-subtitle">
                <div>
                    <h2>Categorías</h2>
                    <h6>Operaciones</h6>
                </div>
                <Link className="btn-dark" to={"/operator/details-rewardCategory/0"}>
                    <p>Agregar Categoría</p>
                    <FaPlus />
                </Link>
            </div>
            <Row>
                <Col sm={12}>
                    <SearchRewardCategory refresh={refresh} />
                </Col>
            </Row>

        </>
    );
}
